var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"id":"briller-carousel"}},[_c('div',{attrs:{"id":"carousel-slider"}},[_c('v-carousel',{attrs:{"align":"center","justify":"center","height":"400","hide-delimiter-background":""}},_vm._l((_vm.items),function(item,i){return _c('v-carousel-item',{key:i,attrs:{"src":item.src,"alt":item.alt}})}),1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }